export const APP_DEVICE_ID_STORAGE_KEY = 'app-device-id'
